import { useAuth } from '@/context/AuthContext'
import { Building2, LogIn } from 'lucide-react'

// RBAC v2: sistem invite-only — departemen & role ditentukan admin saat invite.
// Halaman ini hanya muncul untuk akun lama yang departemennya belum diatur:
// tidak ada lagi pilihan departemen sendiri, cukup arahkan ke admin.
// Departemen tersimpan di sesi login (JWT), jadi setelah admin mengaturnya
// user perlu login ulang agar sesi barunya terbaca.
export default function OnboardingPage() {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-[#F5F4F0] flex items-center justify-center p-6">
      <div className="bg-white border border-[#E8E7E3] rounded-2xl p-8 max-w-md w-full text-center">
        <Building2 className="w-8 h-8 text-[#C0BDB6] mx-auto mb-3" />
        <h1 className="font-display text-lg font-bold text-[#1A1916]">Departemen Belum Diatur</h1>
        <p className="text-sm text-[#8A8A85] font-body mt-2 leading-relaxed">
          Akun <span className="font-semibold text-[#6B6860]">{user?.email}</span> belum
          punya departemen. Hubungi admin untuk mengatur departemen dan role kamu,
          lalu login ulang.
        </p>
        <a
          href="/auth/logout"
          className="mt-5 inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 bg-[#1A1916] text-white rounded-xl text-sm font-body font-semibold hover:bg-[#2E2E2A] active:scale-[0.99] transition-all"
        >
          <LogIn className="w-4 h-4" />
          Login Ulang
        </a>
      </div>
    </div>
  )
}
